import FounderGroq from './Founder';

export default `{
  'founders': hero.founders[]->${FounderGroq},
  'type': hero._type,
  'headline': hero.headline,
}`;
